import { ActionCreatorWithoutPayload, createAction} from "@reduxjs/toolkit";

export namespace MainAuthAction {

  export const authValidation: ActionCreatorWithoutPayload = createAction('AUTH_VALIDATION');
}
